// extracted by mini-css-extract-plugin
export var lg = "_eg-7";
export var md = "_eg-6";
export var placeholderContainer = "_eg-1";
export var placeholderIcon = "_eg-2";
export var productImage = "_eg-0";
export var sm = "_eg-5";
export var xl = "_eg-8";
export var xs = "_eg-4";
export var xxs = "_eg-3";